import { Auth } from "aws-amplify";
import { Button } from 'antd';

export const SignOutButton = () => {
  const onButtonClick = async () => {
    await Auth.signOut();
    window.location.reload();
  };
  return <button onClick={onButtonClick}>Sign Out</button>;
};


export const SignOutLink = () => {
  const onLinkClick = async (e) => {
    await Auth.signOut();
    window.location.reload();
  };
  return <Button type="link" onClick={onLinkClick}>Sign Out</Button>;
};
